<script setup lang="ts">
import { JToaster } from "@jeelsi/jwb-vue-ui/toast";

// Add script to apply jwb-dark class BEFORE Vue hydration
useHead({
  script: [
    {
      innerHTML: `
        (function() {
          // Check localStorage for saved preference
          const savedTheme = localStorage.getItem('jwb-theme');
          
          // Check system preference
          const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
          
          // Apply jwb-dark class IMMEDIATELY
          if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
            document.documentElement.classList.add('jwb-dark');
            // Set CSS variable for immediate background
            // document.documentElement.style.setProperty('--color-body', 'oklch(20.8% 0.042 265.755)');
          } else {
            document.documentElement.classList.remove('jwb-dark');
            // document.documentElement.style.setProperty('--color-body', 'oklch(96.2% 0.018 272.314)');
          }
          
          // Mark as loaded
          document.documentElement.setAttribute('data-theme-loaded', 'true');
        })();
      `,
      tagPosition: "head",
    },
  ],

  // Inline CSS for immediate theme application
  // style: [
  //   {
  //     innerHTML: `
  //       /* Force initial background */
  //       body {
  //         background-color: var(--color-body) !important;
  //         transition: background-color 0.15s ease;
  //       }
  //     `,
  //   },
  // ],

  bodyAttrs: {
    class: "text-primary-fg/85",
  },
});
</script>

<template>
  <!-- Gradient layers -->
  <div id="gradient-light" />
  <div id="gradient-dark" />

  <ColorScheme tag="div" class="root">
    <NuxtLayout>
      <NuxtPage />
      <JToaster />
    </NuxtLayout>
  </ColorScheme>
</template>

<style>
/* Critical: Ensure body has background before hydration */
/* body {
  min-height: 100vh;
  margin: 0;
  background-color: var(--color-body);
} */

/* Apply your gradient styles after theme loads */
/* .jwb-dark body {
  background-image: linear-gradient(
    to left,
    var(--color-body) 0%,
    var(--backgroundd-card) 50%,
    var(--color-body) 100%
  );
}

:root:not(.jwb-dark) body {
  background-image: linear-gradient(
    to left,
    white 0%,
    rgba(0, 0, 0, 0.1) 50%,
    white 100%
  );
} */

/* Smooth transitions */
/* .root {
  transition: background-color 0.15s ease;
} */
</style>
